import cookieHandler from "AtomicUtils/cookieHandler"

// Event types
export const gtmEventTypes = {
  PCPU_ENTER_POSTCODE: "PCPU_ENTER_POSTCODE",
  PCPU_CLOSE_POSTCODE: "PCPU_CLOSE_POSTCODE"
}

// Event creators
export const gtmEvents = {
  [gtmEventTypes.PCPU_ENTER_POSTCODE]: ({ postcode }) => ({
    type: gtmEventTypes.PCPU_ENTER_POSTCODE,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-PCPU-001",
    pageCategory: "Postcode Pop-up",
    pageAction: `Postcode Pop-up - Entered "${postcode}"`
  }),
  [gtmEventTypes.PCPU_CLOSE_POSTCODE]: () => ({
    type: gtmEventTypes.PCPU_CLOSE_POSTCODE,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: "FED-PCPU-002",
    pageCategory: "Postcode Pop-up",
    pageAction: "Postcode Pop-up - closed"
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/postcode-popup-duck.js